import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Dialog, Slide } from '@material-ui/core'

import TermsDialog from './Terms'
import PrivacyDialog from './Privacy'

import { dialogAction } from '../../store/actions'
import { CONSTANTS } from '../../utils/constants'

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />
})

function ContentDialog() {
	let dispatch = useDispatch()
	const { setOpen, popupType } = useSelector((state) => state.action)
	const [open, unsetOpen] = React.useState(setOpen)

	useEffect(() => {
		unsetOpen(setOpen)
	}, [setOpen])

	const handleClose = () => {
		unsetOpen(false)
		dispatch(dialogAction.closeDialog())
	}

	return (
		<div>
			<Dialog
				onClose={handleClose}
				TransitionComponent={Transition}
				aria-labelledby="customized-dialog-title"
				open={open}
				PaperProps={{
					className: CONSTANTS.POPUP_TYPE.TERMS ? 'TermsPopup' : 'PrivacyPopup',
				}}
			>
				{popupType === CONSTANTS.POPUP_TYPE.TERMS ? (
					<TermsDialog handleClose={handleClose} />
				) : (
					<PrivacyDialog handleClose={handleClose} />
				)}
			</Dialog>
		</div>
	)
}

export default ContentDialog
